import { currencyInput } from '@/_schemas/generic';

import { type InvoiceFormSchema, type InvoiceMutationSchema } from '../schemas';

export function invoiceFormToUpdate({
  invoice_date,
  invoice_batch_id,
  client,
  brand,
  partner,
  notes,
  status,
  execution_status,
  due_date,
  invoice_amount,
  digital_invoices_pdf,
  printable_invoices_pdf,
  ...rest
}: InvoiceFormSchema): InvoiceMutationSchema {
  return {
    ...rest,
    invoice_date: invoice_date,
    invoice_batch_id: invoice_batch_id,
    client_id: client?.id ?? -1,
    brand_id: brand?.id ?? null,
    partner_id: partner?.id ?? null,
    notes,
    status,
    execution_status,

    due_date,
    invoice_amount: currencyInput.formToUpdateConverter(invoice_amount),
    digital_invoices_pdf: digital_invoices_pdf?.map((pdf) => pdf.id) ?? [],
    printable_invoices_pdf: printable_invoices_pdf?.map((pdf) => pdf.id) ?? [],
  };
}
